import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import formData from './modules/formData'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    formData,
  },
  getters,
  plugins: [
    createPersistedState()
  ]
})

export default store